import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FaBuilding, FaBolt, FaRupeeSign, FaHandshake } from 'react-icons/fa';
import whyusBg from '../assets/images/whyus-bg.jpg';
import './WhyUs.css';

const reasons = [
  {
    icon: <FaBuilding />,
    title: 'One-Stop Solution',
    desc: 'Registration to revenue, everything under one roof. We eliminate the need to run to multiple agencies.',
    color: '#0a1628',
  },
  {
    icon: <FaBolt />,
    title: 'Fast Processing',
    desc: 'Quick turnaround on all registrations and filings. Your business shouldn\'t wait — and with us, it won\'t.',
    color: '#1a3048',
  },
  {
    icon: <FaRupeeSign />,
    title: 'Affordable Pricing',
    desc: 'Starting at just ₹3,999 for new businesses. Professional services designed for every budget.',
    color: '#112240',
  },
  {
    icon: <FaHandshake />,
    title: 'Expert Support',
    desc: 'Dedicated experts for every service. You get real humans who care about your business success.',
    color: '#0d1e38',
  },
];

export default function WhyUs() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <section className="section why-us" id="why-us" style={{ backgroundImage: `url(${whyusBg})` }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <p className="section-label">Our Advantage</p>
          <h2 className="section-title">Why Businesses Trust<br />RRP & Associates</h2>
          <div className="gold-divider" />
        </motion.div>

        <motion.div
          ref={ref}
          className="why-us__grid"
          initial="hidden"
          animate={inView ? 'show' : 'hidden'}
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.12 } } }}
        >
          {reasons.map((r) => (
            <motion.div
              key={r.title}
              className="why-card"
              variants={{
                hidden: { opacity: 0, y: 40 },
                show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
              }}
              whileHover={{ y: -6, boxShadow: '0 16px 40px rgba(0,0,0,0.12)' }}
            >
              <div className="why-card__icon" style={{ background: r.color }}>
                {r.icon}
              </div>
              <h3 className="why-card__title">{r.title}</h3>
              <p className="why-card__desc">{r.desc}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="why-us__cta"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <a
            href="#contact"
            className="btn-primary"
            style={{ color: 'var(--navy)' }}
            onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
          >
            Start Your Business Today
          </a>
        </motion.div>
      </div>
    </section>
  );
}
